<template>
  <div>
    <my-asidebar v-bind:active-tab="'cruise'"> </my-asidebar>
    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Cruise</h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li><a :href="basePath+'/cruises'" class="text-white">Cruise</a></li>
                    <li>Detay</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <cruise-detail></cruise-detail>
      </div>
    </section>
  </div>
</template>

<script>
import CruiseDetail from "../component/cruise/CruiseDetail";
import TopBar from "../component/common/TopBar";
import MyAsidebar from "../component/common/MyAsidebar";

export default {
  name: "CruiseDetailPage",
  components: {MyAsidebar, TopBar,  CruiseDetail},
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_CRUISE_DETAIL"]) this.$router.push("/");

    if(this.$route.params.id !== undefined && this.$route.params.id !== 'new') {
      this.$store.dispatch("loadCruise", this.$route.params.id)
          .then(response => {
            this.$store.dispatch("loadRoomList", this.$route.params.id);
            this.$store.dispatch("loadDeckList", this.$route.params.id);
            this.$store.dispatch("loadCruiseRoomList", this.$route.params.id);
            this.$store.dispatch("loadCabinTypeList");
          })
          .catch(reason => {
            this.$router.push("/");
          })
    }
  }
}
</script>

<style scoped>

</style>